import { Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle, Icon, Typography, TextField } from '@mui/material';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import AptaTable from 'examples/AptaTable';
import MDBox from 'components/MDBox';
import axios from 'axios';
import { SERVER_URL } from 'constants/constant';
import Swal from 'sweetalert2';

const Author = ({ name, email }) => (
    <MDBox lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
    </MDBox>
);

function MyAbstracts() {
    const myId = localStorage.getItem('adminId');
    const [abstracts, setAbstracts] = useState([]);
    const [open, setOpen] = useState(false);
    const [details, setDetails] = useState(null);
    const [marks, setMarks] = useState('');
    const [comment, setComment] = useState('');

    const fetchData = async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/get-assigned-abstracts/${myId}`);
            setAbstracts(response.data?.abstracts);
        } catch (error) {
            console.error("Error fetching abstracts:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleOpen = (item) => {
        setDetails(item);
        const assignedMark = item?.marks?.find(i => i?.judgeId === myId)?.score || '';
        setMarks(assignedMark);
        setComment('');
        setOpen(true);
    };
    const handleMarksChange = (abstractId, value) => {
        if (value === '' || (Number(value) >= 0 && Number(value) <= 50)) {
            setMarks((prev) => ({ ...prev, [abstractId]: value }));
        }
    };
    const handleClose = () => setOpen(false);

    const handleSubmitMarks = async () => {
        handleClose();
        const score = Number(marks[details?._id]);
        console.log(marks);
        if (isNaN(score) || score < 0 || score > 50) {
            Swal.fire("Please enter a valid mark between 0 and 50");
            return;
        }

        try {
            await axios.post(`${SERVER_URL}/submit-marks/${details?._id}`, {
                judgeId: myId,
                score,
                comment,
            });
            Swal.fire("Marks submitted successfully");
            fetchData();
        } catch (error) {
            console.error("Error submitting marks:", error);
            Swal.fire("Failed to submit marks");
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <AptaTable
                columns={['Title', 'View', 'Marks']}
                rows={abstracts.map((item) => ({
                    Title: item.title,
                    Category: item.category?.catName,
                    Subcategory: item.subCategory?.subCatName,
                    Author: <Author name={item.userId?.firstName + ' ' + item.userId?.lastName} email={item.userId?.email} />,
                    Status: item.status,
                    Marks: item?.marks?.find(i => i?.judgeId === myId) ? (
                        <p style={{ color: 'green' }}>{item?.marks?.find(i => i?.judgeId === myId)?.score}</p>
                    ) : 'No marks assigned',
                    View: (
                        <ButtonGroup size='small'>
                            <Button color='info' onClick={() => handleOpen(item)}>
                                <Icon color='info'>visibility</Icon>
                            </Button>
                        </ButtonGroup>
                    )
                }))}
            />
            {details && (
                <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
                    <DialogTitle style={{ color: 'white' }} sx={{ bgcolor: '#1565c0', color: 'white', textAlign: 'center', fontWeight: 'bold', py: 2, fontSize: '1.5rem' }}>
                        <Icon sx={{ mr: 1 }}>info</Icon> Abstract Details
                    </DialogTitle>
                    <DialogContent sx={{ p: 4, bgcolor: '#fafafa' }}>
                        <Box display='flex' flexDirection='column' gap={3}>
                            <Typography variant='h5' fontWeight='bold'>{details.title}</Typography>
                            <Typography variant='body2'><strong>Category:</strong> {details.category?.catName}</Typography>
                            <Typography variant='body1'>{details.description}</Typography>
                            <Box>
                                <p>Comment:</p>
                                <Typography variant='body2'>{details?.marks?.find(i => i?.judgeId === myId)?.comment || "NA"}</Typography>
                            </Box>
                            {!details?.marks?.find(i => i?.judgeId === myId) && <> <TextField
                                label='Marks (0-50)'
                                fullWidth
                                type='number'
                                // size='small'
                                value={marks[details?._id] || ''}
                                onChange={(e) => handleMarksChange(details?._id, e.target.value)}
                                inputProps={{ min: 0, max: 50 }}
                            />
                                <TextField
                                    label='Comments'
                                    multiline
                                    rows={3}
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    fullWidth
                                /></>}
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'center', p: 3, bgcolor: '#f0f0f0' }}>
                        <Button style={{ color: 'white' }} onClick={handleClose} variant='contained' color='secondary'>
                            Close
                        </Button>
                        {!details?.marks?.find(i => i?.judgeId === myId) && <Button style={{ color: 'white' }} onClick={handleSubmitMarks} variant='contained' color='primary'>
                            Submit Marks
                        </Button>}
                    </DialogActions>
                </Dialog>
            )}
        </DashboardLayout>
    );
}

export default MyAbstracts;